import React from 'react'

const page404 = () => {
    return <div>Je nám líto, ale stránka nebyla nalezena</div>
}

export default page404
